import {
  ShoppingCartOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import styles from "../styles/Content.module.css";

const summaryItems = [
  { key: "orden_entregada", label: "Total de Órdenes Entregadas", icon: <ShoppingCartOutlined /> },
  { key: "orden_cancelada", label: "Total de Órdenes Canceladas", icon: <CloseCircleOutlined /> },
  { key: "orden_rechazada", label: "Promedio de Órdenes Rechazadas", icon: <StopOutlined /> },
  { key: "orden_rechazada", label: "Tiempo Promedio de Entrega", icon: <ClockCircleOutlined />, suffix: "" },
  { key: "ticket_promedio", label: "Ticket Promedio Diario", icon: <DollarOutlined />, prefix: "$" },
  { key: "tiempo_promedio", label: "Promedio de Órdenes Diarias", icon: <BarChartOutlined /> },
];

const Summary = ({ summary }) => {
  return (
    <div className={styles.cardContent}>
      <div className={styles.summaryGrid}>
        {summaryItems.map((item, idx) => (
          <div key={idx} className={styles.summaryCard}>
            <div className={styles.summaryIconWrap}>
              {item.icon}
            </div>
            <p className={styles.summaryValue}>
              {item.prefix && <span>{item.prefix}</span>}
              {summary[item.key]}
            </p>
            <p className={styles.summaryLabel}>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Summary;
